/**
 * Separate bootstrap file so that it application code is executed only after all remoteEntry.js files
 *
 * Order:
 * this index.tsx -> remoteEntry.js -> bootstrap.tsx
 */
import('./bootstrap')
